import React, { useContext } from 'react';
import { map } from 'lodash';
import classnames from 'classnames';
import { FocusBaseContext } from '../../contexts';
import renderRawHtml from '../../../../../common/render_raw_html';
import Closed from './closed';
import OpenEnd from './openEnd';
import StatsTable from './statsTable';

const Followups = () => {
  const { followups, conceptById } = useContext(FocusBaseContext);

  const pluralizeAnswers = (count) => (`${count} answer${count === 1 ? '' : 's'}`);

  return (
    <>
      {
        !!followups.length &&
        <section className="survey-followups-stats">
          <div className="survey-followups-stats_wrapper">
            <h3>Answers on follow-up questions</h3>
            {
              map(followups, (followup, index) => (
                <div
                  key={ `followup-${index}` }
                  className={
                    classnames(
                      "survey-followup-stats",
                      { '-cloud': followup.kind === 'open_ended' }
                    )
                  }
                >
                  <h4 className="survey-followup-stats_header">
                    <span
                      className="survey-followup-stats_header-content"
                      { ...renderRawHtml(followup.question) }
                    />
                    <span className="survey-followup-stats_header-answers-counter">
                      { pluralizeAnswers(followup.total) }
                    </span>
                  </h4>
                  <div className="survey-followup-stats_number">{ index + 1 }</div>
                  { followup.kind === 'closed' && <Closed followup={ followup } /> }
                  { followup.kind === 'open_ended' && <OpenEnd followup={ followup } /> }
                  {
                    followup.kind === 'tags' &&
                    <StatsTable followup={ followup } conceptById={ conceptById } />
                  }
                </div>

              ))
            }
          </div>
        </section>
      }
    </>
  );
};

export default Followups;
